import { useSubscription } from '@apollo/client/react';
import { BookingUpdateDocument, type CompleteBookingFragment } from '@drycut/graphql';
import { useEffect } from 'react';

type Props = {
  callback?: (booking: CompleteBookingFragment) => void;
  uid: string;
};

export function useBookingPubSub({ uid, callback }: Props) {
  const { data } = useSubscription(BookingUpdateDocument, { variables: { uid } });
  const broadcast: CompleteBookingFragment | undefined = data?.bookingUpdate;

  useEffect(() => {
    if (broadcast) {
      // The callback is intentionally an imperative side effect.
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
      callback?.(broadcast);
    }
  }, [broadcast, callback]);
}
